<template>
  <div id="menuItem">
    <nav>
      <el-menu :default-active="activeIndex" :router="true" class="el-menu-demo">
        <!-- 操作管理 -->
        <el-menu-item
            v-if="subjectType == 'ACTOR'"
            index="/operationGuide">
            <span class="el-icon-s-tools"></span>
            {{ $t('operationGuide') }}
        </el-menu-item>
        <!-- 公司管理 index="/company-management"-->
        <el-menu-item
            v-if="!noAdmin && subjectType == 'ACTOR'"
            index="/company-info">
            <span class="iconfont iconshow_gongsiguanli1"></span>
            {{ $t('companyManage') }}
        </el-menu-item>
        <!-- 展商资料 -->
        <el-menu-item index="/exh-Information" v-if="subjectType === 'ACTOR'">
           <span class="iconfont-el el-icon-coin"></span>
          {{ $t('Exhibitor information') }}
        </el-menu-item>
        <!-- 展品管理 -->
        <el-menu-item index="/my-exhibit-list" v-if="subjectType === 'ACTOR'">
           <span class="iconfont-el el-icon-coin"></span>
          {{ $t('exhibitsManage') }}
        </el-menu-item>
        <!-- 员工管理 -->
        <el-menu-item index="/my-employee-list" v-if="!noAdmin && subjectType == 'ACTOR'">
          <span class="iconfont iconguanzhong_weixuanzhong"></span>
          {{ $t('finds.employeeeManage') }}
        </el-menu-item>
        <!-- 个人中心 -->
        <!-- <el-submenu index="1">
          <template slot="title"><span class="iconfont iconwode_weixuanzhong"></span>{{ $t('profile') }}</template>
          <el-menu-item
            v-if="(subjectType=='VISITOR' && !$config.settings.onlayReg2) || subjectType === 'ACTOR'"
            :index="subjectType === 'ACTOR' ? '/footprint/person' : '/footprint/exhibitor'"
          >{{ $t('watchHistory') }}</el-menu-item>
          <el-menu-item
            v-if="(subjectType=='VISITOR' && !$config.settings.onlayReg2) || subjectType === 'ACTOR'"
            :index="subjectType === 'ACTOR' ? '/collection/audience' : '/collection/exhibitor'"
          >{{ $t('myFavorite') }}</el-menu-item>
        </el-submenu> -->
        <!-- 消息中心 -->
        <!-- <el-submenu index="2" 
          v-if="(subjectType === 'ACTOR') || (subjectType === 'VISITOR' && !$config.settings.onlayReg2)" 
          :class="{ 'has-new-msg': newMessageComing || newMailComing }">
          <template slot="title">
            <span class="iconfont iconxiaoxi_weixuanzhong"></span>
            {{ $t('notification') }}
          </template>
          <el-menu-item index="/chat">
            <el-badge :is-dot="newMessageComing" class="item">{{ $t('Send message') }}</el-badge>
          </el-menu-item>
          <el-menu-item index="/mail">
            <el-badge :is-dot="newMailComing" class="item">{{ $t('Message management') }}</el-badge>
          </el-menu-item>
        </el-submenu> -->
        <!-- 在线客服 -->
        <!-- <el-submenu index="3" v-if="onlineServices.name && ((subjectType === 'VISITOR' && !$config.settings.onlayReg2) || (!$config.settings.noActor2 && subjectType === 'ACTOR'))">
          <template slot="title">
            <span class="iconfont iconshow_dianhua"></span>
            {{ $t('Online Service') }}
          </template>
          <el-menu-item @click="customerService(onlineServices)">
            {{ onlineServices.name }}
          </el-menu-item>
        </el-submenu> -->
        <!-- 邀约管理 -->
        <!-- <el-menu-item index="/invite" v-if="(subjectType === 'ACTOR') || (subjectType === 'VISITOR' && !$config.settings.onlayReg2)">
          <span class="iconfont iconyaoyue"></span>
          {{ $t('invitationManagement') }}
        </el-menu-item> -->
        <!-- 商机管理/商脉圈 marketing -->
        <!-- <el-submenu index="7" v-if="subjectType == 'ACTOR' || (subjectType == 'VISITOR' && !$config.settings.onlayReg2)">
          <template slot="title">
            <span class="iconfont iconshangmaiquan"></span>
            {{ $t('finds.businessCircle') }}
          </template>
          <el-menu-item index="/opportunity-manage/list">{{$t('my_releases')}}</el-menu-item>
          <el-menu-item index="/opportunity-manage/publish">{{$t('release_requirements')}}</el-menu-item>
        </el-submenu> -->
      </el-menu>
    </nav>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

import { allocationCustomerService, getFetchList } from '@/api'
export default {
  name: 'menuItem',
  components: {},
  data() {
    return {
      activeIndex: ''
    }
  },
  computed: {
    ...mapState(['newMessageComing', 'newMailComing', 'onlineServices', 'onlineServiceTel']),
    ...mapGetters(['language', 'name', 'isLogin', 'info', 'subjectType', 'exhibitionId', 'exhibitorId']),
    noAdmin() {
      return (
        !this.info || (this.info && !this.info.exhibitorEmployee) || (this.info && this.info.exhibitorEmployee && !this.info.exhibitorEmployee.admin)
      )
    },
    ...{
      iHref() {
        return (this.$config.invitation && this.info && this.info.userAccountId) ? (this.$config.invitation + this.exhibitorId + '&exhibitionId=' + this.exhibitionId + "&userAccountId=" + this.info.userAccountId) : ''
      }
    }
  },
  watch: {
    $route: function() {
      this.menuActive()
    }
  },

  mounted() {
    if (this.onlineServices.length === 0 && this.isLogin) {
      allocationCustomerService({}).then(res => {
        this.$store.commit('setOnlineServices', res.data.data)
      })
      getFetchList({})
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.data) {
            res.data.config && this.$store.commit('setOnlineServiceTel', res.data.config.customServiceTelephone)
          }
        })
    }

    this.$nextTick(() => {
      this.menuActive()
    })
  },
  methods: {
    // goProductCollection() {
    //   queryProductCollection({})
    //     .then(res => {
    //       return res.data
    //     })
    //     .then(res => {
    //       if (res.data) {
    //         window.location.href = res.data
    //       }
    //     })
    // },
    menuActive: function() {
      let path = this.$route.path
      if (this.$route.meta && this.$route.meta.pPath) {
        if (typeof this.$route.meta.pPath === 'string') {
          path = this.$route.meta.pPath
        } else {
          path = this.$route.meta.pPath[this.subjectType]
        }
      }
      this.activeIndex = path
      if(this.$route.path.indexOf('hotspot-detail') !== -1) {
        this.activeIndex = '/hotspot'
      }
    },
    customerService(item) {
      item.position = this.$t('Online Service')
      this.$store.commit('setReceiver', item)
      this.$store.commit('toogleChatDialog')
    },

    toVersionLog() {
      this.$router.push('/versionLog');
    }
  }
}
</script>
<style lang="stylus">
#menuItem {
  width: 200px;
  position: fixed;
  top: 68px;
  left: 50%;
  margin-top: 30px;
  margin-left: calc(-1336px / 2);
  max-height: calc(100% - 98px - 30px);
  overflow: hidden;
  overflow-y: auto;
  z-index 100;

  .el-menu {
    border-right: none;
  }

  .external_link {
    color: $color-black-85;
  }
  .external_link:hover{ 
    color: $color-main;
  }

  .el-menu-item_link:hover{ 
    .external_link{ 
      color: $color-main;
    }
  }

  .el-menu-item, .el-submenu__title {
    height: 44px !important;
    line-height: 44px !important;
    min-width: 200px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding 0 3px  !important;
  }
  .el-menu--inline{
    .el-menu-item{
      padding-left: 34px !important;
    }
  }
  
  .el-menu-item:hover, .el-menu-item:focus, .el-submenu__title:hover, .el-submenu__title:focus {
    position: relative;
    background-color: transparent;
    color: $color-main;
  }

  .el-menu-item.is-active {
    background-color: $color-main !important;
    color: $color-white !important;
  }
  .has-new-msg:after{
    content :''
    width 7px
    height 7px
    position absolute
    top: 8px;
    left : 14%;
    border-radius 50%
    background-color $color-red-f5
  }
  .has-new-msg{
    position relative
  }

  &.grayBackground {
    .el-menu{
      background $color-gray-fb
    }
  }

  .iconfont-el {
    font-size: 14px;
    margin: 9px 8px;
    width: auto;
  }

}

@media screen and (max-width: 1366px) {
    #menuItem {
      left: 0;
      margin-left: 15px;
    }
}
</style>
